import React, { useState } from 'react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');
  
  const galleryImages = [
    {
      id: 1,
      url: 'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg',
      category: 'premium',
      title: 'Premium Room View',
      description: 'Luxurious Premium Room with elegant decor and city view'
    },
    {
      id: 2,
      url: 'https://images.pexels.com/photos/1571471/pexels-photo-1571471.jpeg?cs=srgb&dl=pexels-fotoaibe-1571471.jpg&fm=jpg',
      category: 'super-deluxe',
      title: 'Super Deluxe Room',
      description: 'Spacious Super Deluxe Room with modern amenities'
    },
    {
      id: 3,
      url: 'https://www.hotelprakashpalace.in/img/gallery/room.jpeg',
      category: 'deluxe',
      title: 'Deluxe Room Interior',
      description: 'Comfortable Deluxe Room with premium bedding'
    },
    {
      id: 4,
      url: 'https://png.pngtree.com/thumb_back/fh260/background/20210907/pngtree-neat-gray-tone-home-living-room-furniture-photography-map-with-pictures-image_795599.jpg',
      category: 'premium',
      title: 'Premium Room Bed Area',
      description: 'King-sized bed in our Premium Room with plush bedding'
    },
    {
      id: 5,
      url: 'https://png.pngtree.com/thumb_back/fh260/background/20210903/pngtree-small-apartment-home-interior-decoration-style-photography-map-with-map-image_794336.jpg',
      category: 'super-deluxe',
      title: 'Super Deluxe Bathroom',
      description: 'Modern bathroom in Super Deluxe Room'
    },
    {
      id: 6,
      url: 'https://png.pngtree.com/thumb_back/fh260/background/20230615/pngtree-contemporary-master-room-interior-design-with-3d-rendering-of-luxury-living-image_3607557.jpg',
      category: 'deluxe',
      title: 'Deluxe Room Seating',
      description: 'Cozy seating area in Deluxe Room'
    },
    {
      id: 7,
      url: 'https://images.unsplash.com/photo-1611892440504-42a792e24d32?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
      category: 'premium',
      title: 'Premium Suite Living Area',
      description: 'Spacious living area in Premium Suite'
    },
    {
      id: 8,
      url: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1558&q=80',
      category: 'super-deluxe',
      title: 'Super Deluxe Workspace',
      description: 'Dedicated workspace in Super Deluxe Room'
    },
    {
      id: 9,
      url: 'https://images.unsplash.com/photo-1566665797739-1674de7a421a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80',
      category: 'deluxe',
      title: 'Deluxe Room Evening View',
      description: 'Evening ambiance in our Deluxe Room'
    },
    {
      id: 10,
      url: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
      category: 'premium',
      title: 'Premium Room Bathroom',
      description: 'Luxurious bathroom with marble finishes'
    },
    {
      id: 11,
      url: 'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1374&q=80',
      category: 'super-deluxe',
      title: 'Super Deluxe Balcony',
      description: 'Private balcony with city views'
    },
    {
      id: 12,
      url: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80',
      category: 'deluxe',
      title: 'Deluxe Room Dining',
      description: 'In-room dining setup in Deluxe Room'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Rooms' },
    { id: 'premium', name: 'Premium' },
    { id: 'super-deluxe', name: 'Super Deluxe' },
    { id: 'deluxe', name: 'Deluxe' }
  ];

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(image => image.category === filter);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const navigateImage = (direction) => {
    if (!selectedImage) return;
    
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let nextIndex;
    
    if (direction === 'next') {
      nextIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      nextIndex = currentIndex === 0 ? filteredImages.length - 1 : currentIndex - 1;
    }
    
    setSelectedImage(filteredImages[nextIndex]);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
    

      {/* Hero Section */}
      <div className="relative overflow-hidden">
        <div 
          className="h-64 md:h-96 bg-cover bg-center relative"
          style={{
            backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(https://www.hotelprakashpalace.in/img/gallery/room5.jpeg)'
          }}
        >
          <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4">
            <h1 className="text-4xl md:text-6xl font-bold mb-4">Room Gallery</h1>
            <p className="text-xl md:text-2xl text-amber-200 max-w-3xl">
              Explore the luxury and comfort of Hotel Prakash Palace through our visual journey
            </p>
            <div className="mt-8 flex items-center space-x-2">
              <div className="w-3 h-3 bg-amber-500 rounded-full animate-pulse"></div>
              <p className="text-lg">Scroll to explore our rooms</p>
            </div>
          </div>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-gray-50 to-transparent"></div>
      </div>

      <main className="container mx-auto px-4 py-12">
        {/* Gallery Filters */}
        <div className="mb-12">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Room Collection</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Browse through our collection of premium, super deluxe, and deluxe rooms. 
              Each space is meticulously designed for your comfort and luxury.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            {categories.map(category => (
              <button
                key={category.id}
                className={`px-6 py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 ${
                  filter === category.id
                    ? 'bg-amber-800 text-white shadow-lg'
                    : 'bg-white text-gray-700 border border-gray-300 hover:border-amber-500 hover:text-amber-700'
                }`}
                onClick={() => setFilter(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>
          
          <div className="text-center text-gray-500">
            <p>Showing {filteredImages.length} of {galleryImages.length} images</p>
          </div>
        </div>

        {/* Masonry Gallery Grid */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {filteredImages.map(image => (
            <div 
              key={image.id} 
              className="break-inside-avoid group relative overflow-hidden rounded-xl shadow-lg transition-all duration-500 hover:shadow-2xl cursor-pointer"
              onClick={() => openLightbox(image)}
            >
              <div className="relative overflow-hidden">
                <img 
                  src={image.url} 
                  alt={image.title}
                  className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-110"
                  loading="lazy"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    <h3 className="text-xl font-bold mb-2">{image.title}</h3>
                    <p className="text-amber-200">{image.description}</p>
                    <div className="mt-4 flex items-center">
                      <span className="px-3 py-1 bg-amber-600 rounded-full text-sm font-medium">
                        {image.category === 'premium' ? 'Premium' : 
                         image.category === 'super-deluxe' ? 'Super Deluxe' : 'Deluxe'}
                      </span>
                      <div className="ml-auto">
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="mt-16 bg-gradient-to-r from-amber-900 to-amber-800 rounded-2xl p-8 md:p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Ready to Experience Our Luxury Rooms?</h2>
            <p className="text-xl text-amber-100 mb-8">
              Book your stay at Hotel Prakash Palace and immerse yourself in unparalleled comfort and hospitality.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-6">
              <button className="bg-white text-amber-800 hover:bg-amber-50 font-bold py-4 px-8 rounded-lg text-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl">
                Book Your Room Now
              </button>
              <button className="bg-transparent border-2 border-white text-white hover:bg-white/10 font-bold py-4 px-8 rounded-lg text-lg transition-all duration-300">
                View Room Rates
              </button>
            </div>
          </div>
        </div>
      </main>

   

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black bg-opacity-95 z-[100] flex items-center justify-center p-4">
          <button 
            className="absolute top-6 right-6 text-white text-3xl z-10 hover:text-amber-400 transition duration-300"
            onClick={closeLightbox}
          >
            ✕
          </button>
          
          <button 
            className="absolute left-4 md:left-8 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-amber-400 transition duration-300"
            onClick={() => navigateImage('prev')}
          >
            ‹
          </button>
          
          <button 
            className="absolute right-4 md:right-8 top-1/2 transform -translate-y-1/2 text-white text-3xl hover:text-amber-400 transition duration-300"
            onClick={() => navigateImage('next')}
          >
            ›
          </button>
          
          <div className="max-w-6xl w-full max-h-[90vh] flex flex-col md:flex-row">
            <div className="md:w-2/3 flex items-center justify-center">
              <img 
                src={selectedImage.url} 
                alt={selectedImage.title}
                className="max-h-[70vh] w-auto object-contain rounded-lg"
              />
            </div>
            
            <div className="md:w-1/3 p-6 md:p-8 text-white">
              <h3 className="text-2xl md:text-3xl font-bold mb-4">{selectedImage.title}</h3>
              <p className="text-gray-300 mb-6">{selectedImage.description}</p>
              
              <div className="mb-6">
                <div className="flex items-center mb-4">
                  <span className={`px-4 py-2 rounded-full text-sm font-medium ${
                    selectedImage.category === 'premium' ? 'bg-amber-600' :
                    selectedImage.category === 'super-deluxe' ? 'bg-purple-600' : 'bg-blue-600'
                  }`}>
                    {selectedImage.category === 'premium' ? 'Premium Room' : 
                     selectedImage.category === 'super-deluxe' ? 'Super Deluxe Room' : 'Deluxe Room'}
                  </span>
                  <span className="ml-auto text-lg font-medium text-amber-300">
                    Image {filteredImages.findIndex(img => img.id === selectedImage.id) + 1} of {filteredImages.length}
                  </span>
                </div>
                
                <div className="space-y-3">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-amber-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Premium Bedding</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-amber-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Air Conditioning</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-amber-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                    <span>Free High-Speed Wi-Fi</span>
                  </div>
                </div>
              </div>
              
              <button className="w-full bg-amber-600 hover:bg-amber-700 text-white font-bold py-4 rounded-lg transition duration-300 flex items-center justify-center">
                <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Book This Room
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;